import { matchingFigure } from './page-search.ts'

function words(text: string): string {
  return (
    text
      .toLowerCase()
      .match(/[\p{L}\p{N}]+/gu)
      ?.join(' ') ?? ''
  )
}

/** Retain direct figure matching, then find a complete figure label inside a question. */
export function questionFigure(
  figures: readonly string[],
  question: string
): string | null {
  const direct = matchingFigure(figures, question)
  if (direct) return direct
  const text = ` ${words(question)} `
  const named = figures.filter(figure => {
    const label = words(figure)
    return label !== '' && text.includes(` ${label} `)
  })
  named.sort(
    (left, right) =>
      words(right).length - words(left).length || left.localeCompare(right)
  )
  return named[0] ?? null
}
